import {
	AddressCoordinatesConstants,
	AddressSectionFields,
} from "globalConstants";

/**
 * Checks if an object is empty.
 * @param {Object} obj - The object to check for emptiness.
 * @returns {boolean} - Returns true if the object is empty, otherwise false.
 */
export const isEmptyObject = obj => {
	return Object.keys(obj).length === 0;
};

/**
 * Checks if all fields in an object are empty.
 * @param {Object} obj - The object to check for empty fields.
 * @returns {boolean} - Returns true if all fields in the object are empty, otherwise false.
 */
export const areGeocodeFieldsEmpty = obj => {
	if (typeof obj !== "object" || obj === null) return false;
	if (Array.isArray(obj)) return obj.length === 0;

	for (let key in obj) {
		if (key === "search_address") continue;

		if (
			obj[key] !== null &&
			obj[key] !== 0 &&
			obj[key] !== "" &&
			obj[key] !== undefined
		) {
			return false;
		}
	}
	return true;
};

/**
 * Retrieves the value at a given path within a nested object.
 * @param {Object} obj - The object from which to retrieve the value.
 * @param {string} path - A string representing the path to the desired value (e.g., "ownerPrincipalSection.owners[0].address").
 * @returns {*} - The value at the specified path, or undefined if the path does not exist.
 */
export function getObjectByPath(obj, path) {
	return path?.split(".")?.reduce((acc, part) => {
		const match = part.match(/(\w+)\[(\d+)\]/);
		if (match) {
			return acc[match[1]][parseInt(match[2], 10)];
		}

		return acc && acc[part];
	}, obj);
}

/**
 * Checks if address coordinates correspond to manual entered
 * @param {Object} {lat, lng} - Pass latitude longitude.
 * @returns {boolean} isManual - Returns true if lat === "91" and/or lng === "181", otherwise false.
 */
export function checkIsLatOrLngManual({ lat, lng }) {
	return (
		lat?.toString() ===
			AddressCoordinatesConstants.ManualAddress.lat.toString() ||
		lng?.toString() ===
			AddressCoordinatesConstants.ManualAddress.lng.toString()
	);
}

/**
 * Checks if all address fields are empty
 * @param {Object} addressObj - Address object to check fields
 * @returns {boolean} - Returns true if all address fields is empty, otherwise false.
 */

export const checkAddressFieldsEmpty = addressObj =>
	![
		addressObj?.[AddressSectionFields.Street.name],
		addressObj?.[AddressSectionFields.City.name],
		addressObj?.[AddressSectionFields.Region.name],
		addressObj?.[AddressSectionFields.PostalCode.name],
		addressObj?.[AddressSectionFields.Country.name],
	].some(str => !!str);

export const generateAutotestValue = (autoTest, name) => {
	let autoTestValue;
	if (!autoTest) {
		autoTestValue = (name.charAt(0).toUpperCase() + name.slice(1)).replace(
			/\s/g,
			"",
		);
	} else {
		autoTestValue = autoTest;
	}
	return autoTestValue;
};

export const getStringWithoutHyphens = value => {
	if (!value) return null;

	return value.replaceAll("-", "");
};
